import InnerComponent from '@Components/Purchase/PurchaseIndent/ViewPurchaseIndent';
import orgContainer from '@Components/AppContainer';

const ViewPurchaseIndent = () => ((orgContainer(InnerComponent)));
export default ViewPurchaseIndent;